import mutations from "./mutations.js";
import actions from "./action.js";

export default {  
  state: {
    details: {},
  },
  getters: {
    fetchedPlanDetails(state) {
      return state.details;
    },
  },
  mutations: mutations,
  actions: actions,
};
